import { UserProfileMenu } from "../../../../User/components/UserProfileMenu";

export const UpSm = () => {

	return <>
		<UserProfileMenu />
	</>
}
